import { gql } from '@apollo/client';

export const CREATE_PORTAL_SESSION = gql`
  mutation createPortalSession {
    createPortalSession {
      portalSession
    }
  }
`;
